const _excluded = ["loading", "disabled", "disableKeyboardInput", "disableErrors", "size", "autoOk", "format", "inputVariant", "variant", "onChange", "highlightDay"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import cn from 'classnames';
import { KeyboardDatePicker as MuiKeyboardDatePicker } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core/styles';
import styles from "./KeyboardDatePicker.module.scss";
import { DateColorful } from "../../icons";
import { Spinner } from "../Spinner";
import typography from "../../foundations/typography.module.scss";
import colors from "../../foundations/colors.module.scss";
import { isSameDay } from 'date-fns';
const standardColor = colors.dark700;
const standardBorderColor = colors.dark900;
const disabledColor = colors.dark500;
const disabledBorderColor = colors.dark300;
const focusedColor = colors.purple800;
const useStyles = makeStyles({
  helperText: {
    fontSize: 12,
    marginTop: 0,
    position: 'absolute',
    bottom: 0,
    width: '100%',
    left: 0,
    transform: 'translateY(100%)',
    lineHeight: 'normal'
  },
  label: {
    fontFamily: typography.fontFamilyLight,
    color: standardColor,
    fontSize: typography.fontSizeP1,
    '&.Mui-disabled': {
      color: disabledColor
    },
    '&.Mui-focused': {
      color: focusedColor
    }
  },
  input: _ref => {
    let {
      disableKeyboardInput
    } = _ref;
    return {
      fontFamily: typography.fontFamilyLight,
      color: standardColor,
      fontSize: typography.fontSizeP1,
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: standardBorderColor
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: standardBorderColor,
        borderWidth: 2
      },
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: focusedColor
        }
      },
      '&.Mui-disabled': disableKeyboardInput ? {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: standardBorderColor
        },
        '& .MuiOutlinedInput-input': {
          color: standardColor
        }
      } : {
        color: disabledColor,
        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: 1,
          borderColor: disabledBorderColor
        },
        '& .MuiOutlinedInput-input': {
          color: disabledColor
        }
      }
    };
  },
  inputInput: {
    lineHeight: '24px',
    paddingTop: 4,
    paddingBottom: 4
  },
  inputInput_medium: {
    height: 38
  },
  inputInput_small: {
    height: 32
  },
  adornedEnd: {
    paddingRight: 0
  }
});
const defaultDayHighlightSkin = 'standard';
export function KeyboardDatePicker(props) {
  const {
      loading,
      disabled,
      disableKeyboardInput,
      disableErrors,
      size = 'medium',
      autoOk = true,
      format = 'MM/dd/yyyy',
      inputVariant = 'outlined',
      variant = 'inline',
      onChange: _onChange,
      highlightDay
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const isDisabled = disabled || loading;
  const testid = props['data-testid'];
  const overrides = useStyles({
    disableKeyboardInput
  });
  const disableErrorsProps = disableErrors ? {
    error: false,
    helperText: null
  } : {};
  return /*#__PURE__*/React.createElement(MuiKeyboardDatePicker, _extends({}, rest, disableErrorsProps, {
    disabled: isDisabled,
    keyboardIcon: loading ? /*#__PURE__*/React.createElement(Spinner, {
      size: 24,
      "data-testid": testid && "".concat(testid, "-loading")
    }) : /*#__PURE__*/React.createElement(DateColorful, {
      style: isDisabled ? {
        opacity: 0.4
      } : undefined
    }),
    autoOk: autoOk,
    format: format,
    inputVariant: inputVariant,
    variant: variant,
    size: size,
    inputProps: _objectSpread({
      'data-testid': testid && "".concat(testid, "-input")
    }, props.inputProps),
    KeyboardButtonProps: _objectSpread({
      'data-testid': testid && "".concat(testid, "-btn")
    }, props.KeyboardButtonProps),
    leftArrowButtonProps: _objectSpread({
      'data-testid': testid && "".concat(testid, "-prev-month")
    }, props.leftArrowButtonProps),
    rightArrowButtonProps: _objectSpread({
      'data-testid': testid && "".concat(testid, "-next-month")
    }, props.rightArrowButtonProps),
    FormHelperTextProps: _objectSpread({
      ['data-testid']: testid && "".concat(testid, "-helper-text"),
      classes: {
        contained: overrides.helperText
      }
    }, props.FormHelperTextProps),
    InputLabelProps: {
      classes: {
        root: overrides.label
      }
    },
    InputProps: _objectSpread({
      disabled: disableKeyboardInput || isDisabled,
      classes: {
        root: overrides.input,
        adornedEnd: overrides.adornedEnd,
        input: cn(overrides.inputInput, overrides["inputInput_".concat(size)])
      }
    }, props.InputProps),
    renderDay: (day, selectedDate, dayInCurrentMonth, dayComponent) => {
      const highlighted = day && dayInCurrentMonth && highlightDay ? highlightDay(day) : false;
      const dayTestId = day && testid ? "".concat(testid, "-day-").concat(day.getMonth() + 1, "-").concat(day.getDate()) : undefined;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.dayWrapper,
        "data-testid": dayTestId
      }, !!highlighted && !(day && selectedDate && isSameDay(day, selectedDate)) && /*#__PURE__*/React.createElement("div", {
        className: cn(styles.dayHighlight, styles[typeof highlighted === 'string' ? highlighted : defaultDayHighlightSkin]),
        "data-testid": dayTestId && "".concat(dayTestId, "-highlighted")
      }), dayComponent);
    },
    onChange: (date, value) => {
      const isValid = date instanceof Date && !isNaN(date.getTime());

      // We make sure Date is returned as startOfDay if valid and null if not.
      // The 3rd party component does not guarantee this.
      _onChange(isValid ? new Date(date.setHours(0, 0, 0, 0)) : null, value);
    }
  }));
}